import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'eventName',
    standalone: false
})
export class EventNamePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'PickUp':
        return 'Lastet';
      case 'Deliver':
      case 'CustomerDeliver':
        return 'Levert';
      case 'UndoPickUp':
        return 'Lastet av';
      case 'UndoDeliver':
        return 'Tatt tilbake';
      case 'UnloadCustomerPickUp':
        return 'Losset innhentingsbil'
      default:
        return value;
    }
  }
}
